import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { BaseOptionSet } from '../../models/stack9/BaseOptionSet';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

type BaseOptionSetDrawerProps = {
  open: boolean;
  onClose: () => void;
  id?: number;
  initialValues?: Partial<BaseOptionSet>;
};

export const BaseOptionSetDrawer = ({
  open,
  onClose,
  id,
  initialValues,
}: BaseOptionSetDrawerProps) => {
  const formFields = [
    { field: 'sequence', colSize: 12 },
    { field: 'is_correct', colSize: 12 },
    { field: 'option' },
    { field: 'negative_response' },
    { field: 'is_active' },
  ];

  return (
    <EntityDrawer
      title="base option set"
      formFields={formFields}
      initialValues={initialValues}
      id={id}
      open={open}
      onClose={onClose}
      screenQueryName={EDetailsQueryNames.GetBaseOptionSetDetails}
      entityName={entityNames.BASE_OPTION_SET}
      editRoute={AppRoutes.BaseRequirementDetail}
      relativePath={AppRoutes.BaseRequirementDetail}
    />
  );
};
